import script from "./AgendamentosView.vue?vue&type=script&setup=true&lang=js"
export * from "./AgendamentosView.vue?vue&type=script&setup=true&lang=js"

import "./AgendamentosView.vue?vue&type=style&index=0&id=779d445a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-779d445a"]])

export default __exports__